module.exports = __webpack_public_path__ + "img/amount.ae7a607c.svg";